import { render } from "./App.vue?vue&type=template&id=f48d8e82&bindings={\"state\":\"data\",\"rodoClose\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script